export const COMMON_HEADER = 'common-header'
export const HOME_HEADER = 'home-header'
export const COLLABORATION_HEADER = 'collaboration-header'
export const COMMON_MODE = 'common-mode'
export const COLLABORATION_MODE = 'collaboration-mode'

export const GO_TO_HOME_PAGE = 'go-to-home-page';

export const COLLECT_NPS_SURVEY = 'collect-nps-survey';
export const UPDATE_LOG_STATE_CHANGED = 'update_log_state_changed';

export const TEXT_MARKUP_MORE_COLOR = 'text-markup-more-color';
export const UPDATE_MARKUP_MORE_COLOR = 'update-markup-more-color';
// user
export const EVENT_USER_INITIALIZE_END = 'ev-user-initialize-end';

// SDK
export const SDK_START_LOAD        = 'sdk-start-load';
export const SDK_FINISH_LOAD       = 'sdk-finish-load';
export const SDK_START_INIT        = 'sdk-start-init';
export const SDK_FINISH_INIT       = 'sdk-finish-init';
export const SDK_RENDER_FIRST_PAGE = 'sdk-render-first-page';
export const SDK_WILL_CLOSE_DOC    = 'willCloseDocument';
export const SDK_BEFORE_OPEN_DOC   = 'beforeOpenFile';
export const SDK_OPEN_DOC_SUCCESS   = 'openFileSuccess';
export const ONLINE_START_LOAD     = 'html-loaded';
export const HOME_PAGE_LOADED      = 'home-page-loaded';
export const USER_SELECT_FILE      = 'user-select-file';

// Collaboration
export const COLLABORATION_START = 'collaboration-start'
export const COLLABORATION_FINISH = 'collaboration-finish'
export const COLLABORATION_CPDF_START = 'collaboration-cpdf-start'
export const COLLABORATION_CPDF_FINISH = 'collaboration-cpdf-finish'
export const COLLABORATION_FILE_UPLOAD_START = 'collaboration-file-upload-start'
export const COLLABORATION_FILE_UPLOAD_FINISH = 'collaboration-file-upload-finish'
export const COLLABORATION_FILE_DOWNLOAD_START = 'collaboration-file-download-start'
export const COLLABORATION_FILE_DOWNLOAD_FINISH = 'collaboration-file-download-finish'
export const COLLABORATION_OPEN_START = 'collaboration-open-start'
export const COLLABORATION_OPEN_FINISH = 'collaboration-open-finish'

//contract general invoice research
export const AI_DOCUMENT_TYPE_GENERAL = 'general';
export const AI_DOCUMENT_TYPE_CONTRACT = 'contract';
export const AI_DOCUMENT_TYPE_INVOICE = 'invoice';
export const AI_DOCUMENT_TYPE_RESEARCH = 'research';
export const AI_SHOW_PLUGIN_PANEL = 'show-ai-panel'

// load behavior 加载插件的时机.
export const WEBPLUGIN_LOAD_BEHAVIOR_FILEOPEN = 'fileOpened';

export const WEBPLUGIN_LOAD_BEHAVIOR_APPINITFINISH = 'appInitFinish';

// eSignCN
export const EVENT_UPDATE_OUT_STAMPS = 'update-out-stamps'

export const LOADING_SDK_STATUS = {
  NONE: 1,
  BEGIN: 2,
  END: 3,
}

export const PWA_INSTALL_STATUS = {
  start: 1,
  installing: 2,
  installed: 3,
  cancel: 4
}

export const SavedToSharePointNotificationSucceed = {
  title: 'Notification.FileUploadSucceeded',
  info: 'Notification.SavedToSharePoint',
  type: 'complete'
}
export const SavedToSharePointNotificationFailed = {
  title: 'Notification.FileUploadFailed',
  info: 'Notification.SavedToSharePointFailed',
  type: 'error',
  errorBtnText: 'Notification.SaveAgain'
}
export const UploadingToSharePointNotification = {
  title: '',
  info: 'Notification.FileUploading',
  type: 'upload',
}
// 导航结束事件
export const NAVIGATION_OVER = 'navigation_over';
// AC STORAGE权限切换事件
export const SWITCH_CLOUD_ONLINE_STORAGE = 'switch_cloud_online_storage';